import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x2A800000 {
  modbus: number;
}

export function Command0x2A800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    modbus: 0,
  };

  const [fields, setFields] = React.useState<Form0x2A800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x2A800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.modbus) {
      params.modbus = 0;
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="modbus"
          label="Адрес Modbus БВВ, с которого нужно прочитать сигнатуру"
          margin="dense"
          fullWidth
          value={fields.modbus}
          onChange={handleChangeField("modbus")}
        />
      </FormControl>
    </>
  );
}
